// ================================================= /
// ======   MAIN JS  =============================== /
// ================================================= /

/* global jQuery */

// Import vendor scripts

import gsap from 'gsap';
gsap.config( { force3D: true, nullTargetWarn: false } );

import './inc/vendor/skip-link-focus-fix';
import './inc/vendor/navigation';
import './inc/vendor/jquery-mobile-touchevents.min';
import './inc/vendor/closestDescendant.min';
import './inc/vendor/straightjacket-scripts-core-jquery';
import './inc/vendor/popover-modals-jquery.js';

// Import main scripts

import setup from './inc/setup';
import preloader from './inc/preloader';
import cookiesConsentBar from './inc/cookies-consent-bar';
import hoverTimer from './inc/hover-timer';
import subnav from './inc/subnav';
import slider from './inc/slider';
import statisticsRow from './inc/statistics-row';
import cardRow from './inc/card-row';
import cardDeck from './inc/card-deck';
import superlatives from './inc/superlatives';
import accordion from './inc/accordion';
import table from './inc/table';
import form from './inc/form';

// Animations

import animation from './inc/animation';
import interactive from './inc/interactive';
import homePhone from './inc/animations/home-phone';

// Import plugin scripts

import gravityForms from './inc/plugins/gravity-forms';
import hubspot from './inc/plugins/hubspot';

const jQueryWindow = jQuery( window );

jQueryWindow.on(
	'load',
	function() {

		// Main scripts

		cookiesConsentBar.initialize();
		hoverTimer.initialize();
		subnav.initialize();
		slider.initialize();
		statisticsRow.initialize();
		cardRow.initialize();
		cardDeck.initialize();
		superlatives.initialize();
		accordion.initialize();
		table.initialize();
		form.initialize();

		// Animations

		interactive.initialize();
		homePhone.initialize();

		// Initialize plugin scripts

		gravityForms.initialize();
		hubspot.initialize();

		// Setup

		setup.initialize();
	}
);

jQueryWindow.on(
	setup.finishEvent,
	function() {
		preloader.initialize();
	}
);

jQueryWindow.on(
	preloader.finishEvent,
	function() {
		animation.initialize();
	}
);

console.log( 'Odin says: "Go forth in the name of Valhalla."' );



// WEBPACK FOOTER //
// ./src/js/main.js